/** The credential vault's two views. */
export enum CredentialVaultTab {
  Credentials = "credentials",
  Files = "files",
}
